module.exports = "/wp-content/themes/conversion/public/dist//svgs/icon-send.svg";